import clientAuth from "../clientAuth";
import client from "../client";
let lng = localStorage.getItem('lng') ? localStorage.getItem('lng'):'de';
export default {
  
//  show: (id) => clientAuth.get(`document/show/${id}`),
 show: (id) => clientAuth.get(`trip_review/show/${id}?lng=`+lng),
 store: (userData) => clientAuth.post('trip_review/store', { json: userData }),
};